import { Transform, Type } from 'class-transformer';
import {
	ArrayMaxSize,
	IsArray,
	IsIn,
	IsInt,
	IsOptional,
	IsString,
	Matches,
	Max,
	MaxLength,
	Min,
} from 'class-validator';
import { toStringList } from './courses-dto.util';

const TAG_KEY_RE = /^[a-z][a-z0-9_]{1,48}$/;

export const COURSES_ACCESS_REQUEST_STATUSES = ['pending', 'approved', 'declined'] as const;
export type CoursesAccessRequestStatus = (typeof COURSES_ACCESS_REQUEST_STATUSES)[number];

export class CoursesListAccessRequestsQueryDto {
	@IsOptional()
	@IsString()
	@MaxLength(200)
	q?: string;

	@IsOptional()
	@IsIn(COURSES_ACCESS_REQUEST_STATUSES)
	status?: CoursesAccessRequestStatus;

	@IsOptional()
	@Transform(toStringList)
	@IsArray()
	@ArrayMaxSize(50)
	@Matches(TAG_KEY_RE, { each: true, message: 'Invalid tag' })
	currentTags?: string[];

	@IsOptional()
	@Transform(toStringList)
	@IsArray()
	@ArrayMaxSize(50)
	@Matches(TAG_KEY_RE, { each: true, message: 'Invalid tag' })
	requestedTags?: string[];

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(1)
	@Max(100000)
	page?: number;

	@IsOptional()
	@Type(() => Number)
	@IsInt()
	@Min(1)
	@Max(100)
	pageSize?: number;
}
